import React from 'react';

const BASE = 'https://customer-assets-jt897jd0.emergentagent.net/job_8e1f2105-ed1f-475a-a099-5d324eeb323f/artifacts/';

const INSTITUTIONS = [
  { id: 'canada', name: 'Embajada de Canadá', src: `${BASE}7d7b54863a6bb66f_Copia%20de%20canada%20.png` },
  { id: 'state-dept', name: 'U.S. Department of State', src: `${BASE}2b30844e8ac16a0a_Copia%20de%20dos_seal-1.png` },
  { id: 'fonatur', name: 'FONATUR', src: `${BASE}4b5cc30649873022_Copia%20de%20FONATOUR.png`, scale: 'scale-[1.6]' },
  { id: 'ampi', name: 'AMPI', src: `${BASE}25c568194051b5c9_Copia%20de%20Logo%20AMPI%20Nacional%202019.png`, scale: 'scale-[1.35]' },
  { id: 'amii', name: 'AMII', src: `${BASE}6ac951a0cc3122e8_Copia%20de%20LOGO_AMII.jpg` },
  { id: 'fovissste', name: 'FOVISSSTE', src: `${BASE}f35d1d76dee3a8e8_Copia%20de%20logo-fovissste.jpg`, scale: 'scale-[1.3]' },
  { id: 'coparmex', name: 'COPARMEX', src: `${BASE}84559e2353650d79_Copia%20de%20R.jpg` },
  { id: 'tla', name: 'TLA Financial Services', src: `${BASE}bca2b347851b9d66_Copia%20de%20TLA_FullColor_Brnd%20%281%29.webp` },
  { id: 'uinl', name: 'Unión Internacional del Notariado', src: `${BASE}9a4cb6e9b9cff7c6_Copia%20de%20union%20notarios.webp` },
];

const TrustedInstitutions = ({ title = 'Instituciones que confían en nosotros', subtitle = 'Organismos y asociaciones que trabajan con Notaría Pública 90' }) => (
  <section className="py-16 bg-gray-50" data-testid="trusted-institutions-section">
    <div className="container mx-auto px-4">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-notaria-primary mb-3">{title}</h2>
        <p className="text-gray-600 mb-10 text-center">{subtitle}</p>
        <div className="flex flex-wrap justify-center gap-6">
          {INSTITUTIONS.map((inst) => (
            <div
              key={inst.id}
              data-testid={`institution-${inst.id}`}
              className="w-[calc(50%-0.75rem)] md:w-[calc(33.333%-1rem)] lg:w-[calc(20%-1.2rem)] bg-white rounded-xl border border-gray-200 h-32 flex items-center justify-center p-5 overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-1 transition-[box-shadow,transform] duration-300"
            >
              <img src={inst.src} alt={inst.name} loading="lazy" className={`max-h-full max-w-full object-contain ${inst.scale || ''}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default TrustedInstitutions;
